var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handle}},[(_vm.unschedulable)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("handle.nodeResume"))+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t("handle.nodePause"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }